import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  declarationId: string;
  file: File;
  documentData: {
    type: string;
    referenceNumber: string;
    description: string;
  };
}

export const useUploadProvidedDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, file, documentData }: HookProps) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', documentData.type);
      formData.append('referenceNumber', documentData.referenceNumber);
      formData.append('description', documentData.description);

      const result = await apiClient.declarationsDocuments.uploadProvidedDocument.mutation({
        params: { id: declarationId },
        body: formData,
      });

      if (result.status !== 200) throw result.body;

      return result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
      toast.success('Document uploaded successfully!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error uploading the document!');
    },
  });
};
